import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Attach token from localStorage as fallback (ingress may strip cookies in some setups)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pulse_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      const path = window.location.pathname;
      const onAuthPage = path === "/login" || window.location.hash?.includes("session_id=");
      if (!onAuthPage) {
        localStorage.removeItem("pulse_token");
        localStorage.removeItem("pulse_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export default api;
